import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { ProgramFormsModule } from '@features/program-forms/program-forms.module';
import { RuleAutomationModule } from '@features/rule-automation/rule-automation.module';
import { BudgetAssignmentHistoryPageComponent } from './budget-assignment-history-page/budget-assignment-history-page.component';
import { BudgetAssignmentPageComponent } from './budget-assignment-page/budget-assignment-page.component';
import { ManageBudgetAssignmentPageComponent } from './manage-budget-assignment-page/manage-budget-assignment-page.component';
import { UpdateBudgetAssignmentModalComponent } from './update-budget-assignment-modal/update-budget-assignment-modal.component';

@NgModule({
  imports: [
    GCCoreModule,
    RuleAutomationModule,
    ProgramFormsModule
  ],
  declarations: [
    UpdateBudgetAssignmentModalComponent,
    BudgetAssignmentPageComponent,
    ManageBudgetAssignmentPageComponent,
    BudgetAssignmentHistoryPageComponent
  ],
  exports: [
    UpdateBudgetAssignmentModalComponent
  ]
})
export class BudgetAssignmentsModule { }
